import { render, staticRenderFns } from "./TheNotFound.vue?vue&type=template&id=6987d99c&scoped=true&"
import script from "./TheNotFound.vue?vue&type=script&lang=js&"
export * from "./TheNotFound.vue?vue&type=script&lang=js&"
import style0 from "./TheNotFound.vue?vue&type=style&index=0&id=6987d99c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6987d99c",
  null
  
)

export default component.exports